import { createSlice } from "@reduxjs/toolkit";
import { getUserDetailsFromStorage } from "./../../util/principal";
import { combineReducers } from "redux";

const userSlice = createSlice({
  name: "user",
  initialState: getUserDetailsFromStorage(),
  reducers: {
    loggedIn: (user, action) => {
      const {
        userName,
        emailId,
        role,
        access_token,
        companyName,
        agreementAccepted,
      } = action.payload;
      user.userName = userName;
      user.emailId = emailId;
      user.role = role;
      user.access_token = access_token;
      user.companyName = companyName;
      user.agreementAccepted = agreementAccepted !== undefined ? agreementAccepted : false;
    },
    loggedOut: (user, action) => {
      user.userName = null;
      user.emailId = null;
      user.role = null;
      user.access_token = null;
      user.companyName = null;
      user.agreementAccepted = false;
      // Clear agreement acceptance on logout
      localStorage.removeItem('legalAgreement');
    },
    acceptAgreement: (user, action) => {
      const { userName, accepted } = action.payload;
      user.agreementAccepted = accepted;
      // Store in localStorage with consistent key
      localStorage.setItem('legalAgreement', accepted.toString());
    },
  },
});

export const { loggedIn, loggedOut, acceptAgreement } = userSlice.actions;
export default combineReducers({ user: userSlice.reducer });
